export const TOGGLE_COLLAPSE = '@@nav/TOGGLE_COLLAPSE';
export type TOGGLE_COLLAPSE = typeof TOGGLE_COLLAPSE;
